import React from "react";
import adBg from "../../../assets/job-add.png";
import { Link } from "react-router-dom";

const JobAdd = () => {
  return (
    <div className="my-20">
      <div
        style={{ backgroundImage: `url(${adBg})` }}
        className="bg-cover bg-center rounded-md lg:mx-16 py-32 lg:py-40 mx-auto"
      >
        <h1 className="text-white text-center text-4xl font-semibold mb-2">
          Work with Us
        </h1>
        <span className="text-border text-lg text-center max-w-[570px] mx-auto mb-2">
          Join our team and revolutionize mobility with ZAP! Grow your career
          and make an impact with us.{" "}
        </span>
        <Link to="/join-us" className="w-full">
          <button className="font-semibold text-center mx-auto w-[200px] flex justify-center items-center">
            Come join us
          </button>
        </Link>
      </div>
    </div>
  );
};

export default JobAdd;
